export default __webpack_public_path__ + "static/14-9500b0a8906d881fa4fab548bbadcc54.jpg";